export enum CommunityAdminBanType {
    Permanent = 'permanent',
    Temporary = 'temporary'
}